<template>
    <div class="py-3" v-if="isLoaded">
        <div class="flex pb-2">
            <div class="font-bold text-a-brown-502314 lg:text-18">{{lbl.shoppingcart.your_order_title}}</div>
            <div class="flex bg-a-brown-502314 rounded-full px-2 py-1 ml-auto mr-0 cursor-pointer" @click="clickAddmore()">
                <img src="@/assets/icon/ic-addmore-brown.svg" />
                <div class="text-a-egg-f5ebdc font-bold ml-1 text-14 lg:text-16">{{lbl.shoppingcart.add_more_button}}</div>
            </div>
        </div>
        <CartOrderItem
            v-for="(cartItem) in cartItemList"
            :key="cartItem.rowKey"
            :cartItem="cartItem"
            @updateItem="updateItem()"
            @deleteItem="deleteItem(cartItem)"
            @editOrder="editOrder(cartItem)"
        ></CartOrderItem>
    </div>
</template>

<script>
//config
import ConfigManager from '@/config/ConfigManager.js';
//helper
import CacheHelper from "@/helper/CacheHelper";
//component
import CartOrderItem from "./CartOrderItem.vue";
//service
import { CartItemModel } from '@/core/Cart/model/CartItemModel';
import BKCart from '../service/BKCart.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
export default {
    name: "CartOrder",
    mixins: [LocaleMixin,ModalMixin],
    inject: ['PlaceOrderStore','ShippingStore'],
    components: {
        CartOrderItem
    },
    data: function() {
        return {
            isLoaded: false,
            cartItemList: [],
            promotionList: [],
            
            subtotal: 0,
            deliveryFee: 0,
            discount: 0,
            total: 0,
            KEY_COOKIE_RETURN_URL: 'return_url',
            
            isDisableGoExternal: false
        }
    },
    created: async function() {
        await this.apiGetPromotion();
        if (this.apiGetCartItem()) {
            if (this.PlaceOrderStore.state.placeOrder.coupon) {
                if (this.PlaceOrderStore.state.placeOrder.coupon.type == "discount_to") {
                    if (this.ShippingStore.state.shipping.shippingPrice < this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit) {
                        this.discount = this.ShippingStore.state.shipping.shippingPrice;
                    } else {
                        this.discount = this.ShippingStore.state.shipping.shippingPrice - this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                    } 
                } else {
                    if (this.PlaceOrderStore.state.placeOrder.coupon.codeType == "user") {
                        this.discount = this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                    } else {
                        if (this.ShippingStore.state.shipping.shippingPrice < this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit) {
                            this.discount = this.ShippingStore.state.shipping.shippingPrice;
                        } else {
                            this.discount = this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                        }
                    }
                }
                
            }
            this.isLoaded = true;
        }
    },
    methods: {
        updateItem: function () {
            this.calSummery();
            this.$emit('updateItem');
        },
        deleteItem: async function (cartItem) {
            this.modal.loadingModal.show();
            if (await this.apiDeleteCartItem(cartItem.rowKey)) {
                this.isLoaded = false;
                let tempList = [];
                for(let objCartItem of this.cartItemList) {
                    if (objCartItem.rowKey != cartItem.rowKey) {
                        tempList.push(objCartItem);
                    }
                }
                this.cartItemList = tempList;
                this.isLoaded = true;
                this.modal.loadingModal.hide();
                if (this.cartItemList.length == 0) {
                    this.$emit('orderempty');
                }
                this.$emit('updateItem');
                
                // if (await this.apiGetCartItem()) {
                //     this.isLoaded = true;
                //     this.modal.loadingModal.hide();
                //     this.$emit('updateItem');
                // }
            }
        },
        reLoad: async function () {
            this.modal.loadingModal.show();
            this.isLoaded = false;
            if (await this.apiGetCartItem()) {
                this.isLoaded = true;
                this.modal.loadingModal.hide();
                this.$emit('onReLoadSuccess');
            }
        },
        editOrder: function(cartItem) {
            if (this.isDisableGoExternal) 
                return;
            else
                this.isDisableGoExternal = true;

            let label = 'shopping_bag|' + cartItem.campaignId + '|';
            label += this.localeCode == 1033 ? cartItem.nameEng : cartItem.name;
            this.tracking.event('shopping_bag','click_edit_item', label, null);
            
            let cache = new CacheHelper(ConfigManager.getCacheType());
            let cacheReturnUrl = cache.getCache(this.KEY_COOKIE_RETURN_URL);
            if (cacheReturnUrl) {
                cache.removeCache(this.KEY_COOKIE_RETURN_URL);
                if (cartItem.parentCampaignId) {
                    cacheReturnUrl += "campaign?id=" + cartItem.parentCampaignId
                } else {
                    cacheReturnUrl += "campaign?id=" + cartItem.campaignId
                }
                cacheReturnUrl += "&key=" + cartItem.rowKey;
                
                this.PlaceOrderStore.methods.removePlaceOrder();
                this.ShippingStore.methods.removeShipping();
                setTimeout(()=>{
                    window.location.href = cacheReturnUrl;
                },1000); 
            } else {
                this.PlaceOrderStore.methods.removePlaceOrder();
                this.ShippingStore.methods.removeShipping();
                let campaignId = null;
                if (cartItem.parentCampaignId) { 
                    campaignId = cartItem.parentCampaignId;
                } else {
                    campaignId = cartItem.campaignId;
                }
                this.$router.push("/product/" + campaignId + '?key=' + cartItem.rowKey);
            }
        },
        apiDeleteCartItem: async function(rowKey) {
            return new Promise((resolve) => {
                BKCart.apiDeleteCartItem(rowKey).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetCartItem: async function() {
            return new Promise((resolve) => {
                BKCart.apiGetCartItem().subscribe({
                    next: (data) => {
                        this.cartItemList = data;
               
                        this.calSummery();
                        this.$emit('onLoaded');
                        if (this.cartItemList.length == 0) {
                            this.$emit('orderempty');
                        }
                        resolve(true);
                    },
                    error: (err) => {
                        this.$emit('onLoaded');
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetPromotion: async function() {
            return new Promise((resolve) => {
                BKCart.apiGetPromotion().subscribe({
                    next: (data) => {
                        // console.log("promotion",data.promotion);
                        this.promotionList = data.promotion;
                        // this.cartItemList = data;
                        resolve(true);
                    },
                    error: (err) => {
                        this.$emit('onLoaded');
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        clearPromotion: function() {
            for (let promotionItem of this.promotionList) {
                for (let campign of  promotionItem.campaigns) {
                    let i = 0;
                    for (let cartItem of this.cartItemList) {
                        if (cartItem.campaignId == campign.Id) {
                            this.cartItemList.splice(i, 1);
                        }
                        i++;
                    }
                }
                
            }
        },
        addPromotion: function() {
            
            for (let promotionItem of this.promotionList) {
                if (this.subtotal >= promotionItem.minimum_price) {
                    for (let campign of  promotionItem.campaigns) {
                        let objCartItem = new CartItemModel();
                        objCartItem.setFromPromotion(campign);
                        this.cartItemList.push(objCartItem);
                        // console.log("cartItemList",this.cartItemList);
                    } 
                }
            }
        },
        calSummery: function() {
            this.subtotal = 0;
            for (let cartItem of this.cartItemList) {
                this.subtotal += cartItem.priceItem;
            }
            this.PlaceOrderStore.state.placeOrder.subtotal = this.subtotal;

            this.deliveryFee = this.ShippingStore.state.shipping.shippingPrice;

            // คำนวน Total
            let calDiscount = 0;
            if (this.discount == 0) {
                this.total = this.subtotal + this.deliveryFee;
            } else {
                if (this.PlaceOrderStore.state.placeOrder.coupon.codeType == "user") {
                    calDiscount = this.subtotal - this.discount;
                    if (calDiscount > 0) {
                        this.total = calDiscount + this.deliveryFee;
                    } else {
                        this.total = 0 + this.deliveryFee;
                    }
                } else {
                    this.total = this.subtotal + this.deliveryFee - this.discount;
                }
            }
            // End คำนวน Total
            
            this.PlaceOrderStore.state.placeOrder.total = this.total;
            this.PlaceOrderStore.methods.updatePlaceOrder();
 
            this.isLoaded = false;
            this.clearPromotion();
            this.addPromotion();
            this.isLoaded = true;
            
        },
        getData: function() {
            // console.log(this.cartItemList);
            return this.cartItemList;
        },
        clickAddmore: function() {
            this.tracking.event('shopping_bag','click_add_more', null, null);
            this.$emit('clickAddmore');
        }
    }
}
</script>

<style>

</style>